import StorageService from '../services/StorageService';
import routes from '../router';

export default {
  401: () => {
    StorageService.performLogoutCleanup();
    routes.push({ name: 'login', query: { reload: 1 } }).catch((err) => {
      // ignore NavigationDuplicated errors when already on login page
      if (err.name !== 'NavigationDuplicated') {
        throw err;
      }
    });
  },
  403: () => {},
  500: () => {},
  523: () => {},
  common: () => {},
};
